module.exports = __webpack_public_path__ + "img/question_bottom_left.3d7f2ba7.svg";